export function joinUrl(baseUrl: string, path: string) {
  const url = new URL(baseUrl);

  url.pathname = path;

  return url.toString();
}
